<template>
  <div class="card p-4 shadow-sm">
    <!-- TOAST -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
      <div class="toast show align-items-center text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i>
            {{ alerta.mensaje }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
        </div>
      </div>
    </div>

    <!-- ENCABEZADO -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="m-0">Habitaciones Pendientes de Liberar</h3>
      <button class="btn btn-primary" @click="liberarHabitaciones" :disabled="habitaciones.length === 0">
        Liberar Todas
      </button>
    </div>

    <!-- TABLA -->
    <div class="table-responsive">
      <table class="table table-bordered text-center align-middle">
        <thead class="table-light">
          <tr>
            <th>Número de Habitación</th>
            <th>Estado Actual</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="habitaciones.length === 0">
            <td colspan="4">No hay habitaciones pendientes de liberar.</td>
          </tr>
          <tr v-for="hab in habitaciones" :key="hab.IdHabitacion">
            <td>{{ hab.Numero }}</td>
            <td><span class="badge bg-warning">Pendiente de liberar</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "LiberarHabitaciones",
  data() {
    return {
      habitaciones: [],
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerHabitaciones() {
      try {
        const res = await axios.get(`${API_URL}/habitaciones-pendientes-de-liberar`);
        this.habitaciones = res.data;
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al obtener habitaciones", "danger");
      }
    },
    async liberarHabitaciones() {
      try {
        const res = await axios.put(`${API_URL}/liberar-habitaciones`);
        this.mostrarAlerta(res.data.message || "Habitaciones liberadas");
        this.obtenerHabitaciones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al liberar habitaciones", "danger");
      }
    },
  },
  mounted() {
    this.obtenerHabitaciones();
  },
};
</script>

<style scoped>
.badge {
  font-size: 0.9rem;
  padding: 0.5em 0.75em;
}
</style>
